import React, { useEffect, useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';

import TableComponent from 'app/components/TableComponent';
import { FormControl, InputGroup, Modal } from 'react-bootstrap-v5';
import './styles/detallesbono.css';
import { KTSVG } from '_metronic/helpers/components/KTSVG';
import { formatDecimal, toaster } from 'app/utilities/commons';
import {
  getAllBondsCollaboratorsDepartments,
  getAllBondsCollaboratorsDepartmentsName,
  getAllBondsCollaboratorsDepartmentsNumber,
  putRequestOpening,
  putOpeningAuthorization,
} from 'app/service/bonos/Ajustes';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { updateBondDepartmentCollaborator } from 'app/service/asignacion_bonos/Asignacion_bonos';
import { decodeToken } from 'app/utilities/decodeJWTToken';
import { useSelector } from 'react-redux';
import { RootState } from 'setup';
import axios from 'axios';
import { invalidChar } from 'app/utilities/invalidChar';
import Swal from 'sweetalert2';

const API_URL = process.env.REACT_APP_API_NET;

type BondCollaboratorDepartment = {
  periodId: number;
  collaboratorId: number;
  numEmploye: string;
  nameEmploye: string;
  employeId: number;
  department: string;
  job: string;
  bond: number;
  porcent: number;
  bondId: number;
  bondFinal: number;
  aprovedBy: string;
  requestedBy: string;
  authorizationDate?: string;
  requestDate?: string;
  createDate?: string;
};

type InputFields = {
  name: JSX.Element;
  number: JSX.Element;
};

const BondCollaboratorDepartmentSchema = Yup.object().shape({
  bondAmount: Yup.number()
    .required('Este campo es requerido.')
    .min(1, 'El monto debe ser mayor a 0'),
  bondFinal: Yup.number()
    .required('Este campo es requerido.')
    .min(1, 'El monto debe ser mayor a 0')
    .max(999999, 'El monto no puede ser mayor a 999,999'),
  //! It's hidden when we need to use later for now it's not required
  // bondPercent: Yup.number()
  //   .required('Este campo es requerido.')
  //   .min(0, 'El porcentaje debe ser mayor o igual a 0')
  //   .max(100, 'El porcentaje no puede ser mayor a 100'),
});

const heads = [
  { code: 'numEmploye', label: 'No. Empleado' },
  { code: 'nameEmploye', label: 'Nombre' },
  { code: 'department', label: 'Departamento' },
  { code: 'job', label: 'Puesto' },
  { code: 'bond', label: 'Bono General' },
  { code: 'porcent', label: 'Porcentaje' },
  { code: 'bondFinal', label: 'Bono Total' },
  { code: 'requestedBy', label: 'Revisa' },
  { code: 'aprovedBy', label: 'Autoriza' },
];

const filterOptions = [
  { id: '1', fecha: 'Nombre', field: 'name' },
  { id: '2', fecha: 'Número de Empleado', field: 'number' },
];

const DetalleBono: React.FC = () => {
  const location = useLocation<any>();
  const [periodId, setPeriodId] = useState<any>(location.state?.periodId);

  const [show, setShow] = useState(false);
  const [selectedName, setSelectedName] = useState<string>('');
  const [employeeName, setEmployeeName] = useState('');
  const [employeeNumber, setEmployeeNumber] = useState('');
  const [selectedOption, setSelectedOption] = useState('');

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(5);
  const [bondCollaborator, setBondCollaborator] = useState<
    BondCollaboratorDepartment[]
  >([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [loadingGrid, setLoadingGrid] = useState(true);
  const [loadingInfo, setLoadingInfo] = useState(false);
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [bondId, setBondId] = useState<any>();
  const [isFiltered, setIsFiltered] = useState<boolean>(false);

  const formBondsDepartmentsCollaborator = useFormik<any>({
    validationSchema: BondCollaboratorDepartmentSchema,
    initialValues: {
      bondAmount: '',
      bondPercent: '',
      bondFinal: '',
    },
    onSubmit: async (values, { setSubmitting }) => {
      try {
        await updateBondDepartmentCollaborator(
          bondId,
          values.bondPercent,
          values.bondAmount,
          values.bondFinal
        );
        toaster.success('Se cambio con éxito la información');
        handleClose();
        fetchBondsCollaboratorsDepartments();
        formBondsDepartmentsCollaborator.resetForm();
      } catch (err) {
        console.error('Error', err);
      } finally {
        setSubmitting(false);
      }
    },
  });

  const accessToken: any = useSelector<RootState>(
    (state) => state.auth.accessToken
  );

  const token: any = decodeToken(accessToken);

  const roles = JSON.parse(token?.RoleForDeparment ?? []);
  const [createdDate, setCreatedDate] = useState<any>();
  const [requestedDate, setRequestedDate] = useState<any>();
  const [authorizationDate, setAuthorizationDate] = useState<any>();
  const [canSeeAperturaButtons, setCanSeeAperturaButtons] = useState(false);

  useEffect(() => {
    const fetchUserRoles = async () => {
      try {
        const res = await axios.get(`${API_URL}User/${token.nameid}`);
        const userRoles: any[] = res.data.data.roles || [];
        const hasAllowedRole = userRoles.some(
          (r: any) => r.userRole?.code === 'ADMIN' || r.userRole?.code === 'ADMC'
        );
        setCanSeeAperturaButtons(hasAllowedRole);
      } catch (err) {
        console.error('Error fetching user roles:', err);
      }
    };
    fetchUserRoles();
  }, []);

  const fetchPeriods = async () => {
    try {
      const res = await axios.get(`${API_URL}Period`);
      const filteredPeriod = res.data.data.records.filter(
        (record: { statusId: number }) => record.statusId === 1
      );
      if (filteredPeriod.length > 0) {
        setPeriodId(filteredPeriod[0].id);
      }
    } catch (err) {
      console.error('Error al obtener los periodos:', err);
    }
  };

  useEffect(() => {
    if (!periodId) {
      fetchPeriods();
    }
  }, [periodId]);

  const handleRequestOpening = async () => {
    try {
      await putRequestOpening(token.nameid, periodId);
      toaster.success('Apertura de Revisión realizada con éxito');
      fetchBondsCollaboratorsDepartments();
    } catch (err: any) {
      console.error('Error on Request Opening:', err);
      toaster.error(err.message ?? 'Hubo un error al realizar la apertura de revisión');
    }
  };

  const handleOpeningAuthorization = async () => {
    try {
      await putOpeningAuthorization(token.nameid, periodId);
      toaster.success('Apertura de Autorización realizada con éxito');
      fetchBondsCollaboratorsDepartments();
    } catch (err: any) {
      console.error('Error on Opening Authorization:', err);
      toaster.error(err.message ?? 'Hubo un error al realizar la apertura de autorización');
    }
  };

  const fetchBondsCollaboratorsDepartments = async () => {
    try {
      const res = await getAllBondsCollaboratorsDepartments(
        currentPage,
        pageSize,
        token.nameid,
        periodId
      );
      setBondCollaborator(
        res!.records.map((record) => ({
          ...record,
        }))
      );

      if (res.records && res.records.length > 0) {
        setCreatedDate(res.records[0].createDate?.split('T')[0]);
        setRequestedDate(res.records[0].requestDate?.split('T')[0]);
        setAuthorizationDate(res.records[0].authorizationDate?.split('T')[0]);
      } else {
        setCreatedDate(undefined);
        setRequestedDate(undefined);
        setAuthorizationDate(undefined);
      }

      setLoadingInfo(!loadingInfo);
      setTotalRecords(res!.totalRecords);
      setLoadingGrid(false);
    } catch (err) {
      console.error('Error al obtener BondsCollaboratorDepartment', err);
    }
  };

  const fetchBondsDepartmentsCollaboratorFilterByName = async (
    employeeName: any
  ) => {
    setIsFiltered(true);
    try {
      const res = await getAllBondsCollaboratorsDepartmentsName(
        currentPage,
        pageSize,
        token.nameid,
        employeeName,
        periodId
      );
      setBondCollaborator(
        res!.records.map((record) => ({
          ...record,
        }))
      );
      setTotalRecords(res!.totalRecords);
      setLoadingGrid(false);
    } catch (err) {
      console.error('Error al obtener los datos');
    }
  };

  const authorization = async (idUser: number, isRequest: boolean) => {
    try {
      const res = await axios.put(
        `${API_URL}CollaboratorBonds/PutRequestAuthorization?Id_user=${idUser}&IsRequest=${isRequest}`
      );
      fetchBondsCollaboratorsDepartments();
      toaster.success(res.data.data.mensaje);
    } catch (err) {
      console.error('Error requesting authorization: ', err);
    }
  };

  const requestAuthorization = async (idUser: number, isRequest: boolean) => {
    try {
      const res = await axios.put(
        `${API_URL}CollaboratorBonds/PutRequestAuthorization?Id_user=${idUser}&IsRequest=${isRequest}`
      );
      fetchBondsCollaboratorsDepartments();
      toaster.success(res.data.data.mensaje);
    } catch (err) {
      console.error('Error requesting authorization: ', err);
    }
  };

  const fetchBondsDepartmentsCollaboratorFilterByNumber = async (
    employeeNumber: any
  ) => {
    setIsFiltered(true);
    try {
      const res = await getAllBondsCollaboratorsDepartmentsNumber(
        currentPage,
        pageSize,
        token.nameid,
        employeeNumber,
        periodId
      );
      setBondCollaborator(
        res!.records.map((record) => ({
          ...record,
        }))
      );
      setTotalRecords(res!.totalRecords);
      setLoadingGrid(false);
    } catch (err) {
      console.error('Error al obtener los datos');
    }
  };

  useEffect(() => {
    if (!periodId) return;

    if (isFiltered) {
      if (selectedOption === '1' && employeeName) {
        fetchBondsDepartmentsCollaboratorFilterByName(employeeName);
      } else if (selectedOption === '2' && employeeNumber) {
        fetchBondsDepartmentsCollaboratorFilterByNumber(employeeNumber);
      }
    } else {
      fetchBondsCollaboratorsDepartments();
    }
  }, [currentPage, pageSize, isFiltered, periodId]);

  const handleShow = (
    nombre: string,
    id: number,
    bond: number,
    porcent: number,
    bondFinalAmount: number
  ) => {
    setSelectedName(nombre);
    setBondId(id);

    formBondsDepartmentsCollaborator.setValues({
      bondAmount: bond,
      bondPercent: porcent,
      bondFinal: bondFinalAmount
    });

    setShow(true);
  };

  const handleClose = () => {
    setShow(false);
    formBondsDepartmentsCollaborator.resetForm();
  };

  const handleFilterClose = () => {
    setShowFilterModal(false);
  };

  const handleFilterOpen = () => {
    setShowFilterModal(true);
  };

  const handleSelectChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedOption(e.target.value);
  };

  const handleSearch = () => {
    if (selectedOption === '1' && employeeName) {
      setIsFiltered(true);
      setCurrentPage(1);
      fetchBondsDepartmentsCollaboratorFilterByName(employeeName);
    } else if (selectedOption === '2' && employeeNumber) {
      setIsFiltered(true);
      setCurrentPage(1);
      fetchBondsDepartmentsCollaboratorFilterByNumber(employeeNumber);
    }
  };

  /**
 * Clean all the filters, inputs and fetch again the data
 */
  const handleClearFilters = () => {
    setEmployeeNumber('');
    setEmployeeName('');
    setSelectedOption('');
    setIsFiltered(false);
    setCurrentPage(1);
    fetchBondsCollaboratorsDepartments();
  }

  const inputFields: InputFields = {
    name: (
      <>
        <div className="mt-4">
          <label className="form-label fw-bold">Nombre: </label>
        </div>
        <div>
          <input
            type="text"
            value={employeeName}
            className="form-control mt-4"
            onChange={(e) => setEmployeeName(e.target.value)}
          />
          <div className="mt-4 d-flex flex-row-reverse">
            <button
              type="submit"
              className="btn btn-primary"
              data-kt-menu-dismiss="true"
              onClick={(e) => {
                e.preventDefault();
                handleSearch();
                handleFilterClose();
              }}
            >
              Buscar
            </button>
            <button
              type="reset"
              className="btn btn-white btn-active-light-primary me-2"
              data-kt-menu-dismiss="true"
              onClick={(e) => {
                e.preventDefault();
                handleFilterClose();
                handleClearFilters();
              }}
            >
              Limpiar
            </button>
          </div>
        </div>
      </>
    ),
    number: (
      <>
        <div className="mt-4">
          <label className="form-label fw-bold">Número de Empleado: </label>
        </div>
        <div>
          <input
            type="text"
            value={employeeNumber}
            className="form-control mt-4"
            onChange={(e) => setEmployeeNumber(e.target.value)}
          />
          <div className="mt-4 d-flex flex-row-reverse">
            <button
              type="submit"
              className="btn btn-primary"
              data-kt-menu-dismiss="true"
              onClick={(e) => {
                e.preventDefault();
                handleSearch();
                handleFilterClose();
              }}
            >
              Buscar
            </button>
            <button
              type="reset"
              className="btn btn-white btn-active-light-primary me-2"
              data-kt-menu-dismiss="true"
              onClick={(e) => {
                e.preventDefault();
                handleFilterClose();
                handleClearFilters();
              }}
            >
              Limpiar
            </button>
          </div>
        </div>
      </>
    ),
  };

  const fieldToShow = filterOptions.find(
    (option) => option.id === selectedOption
  )?.field;

  const rows = useMemo(() => {
    if (!loadingGrid && bondCollaborator.length) {
      return bondCollaborator.map((row) => ({
        numEmploye: (
          <div style={{ textAlign: 'center', cursor: 'pointer' }}>
            {row.numEmploye}
          </div>
        ),
        nameEmploye: (
          <div
            style={{ textAlign: 'center', cursor: 'pointer' }}
            className="text-info"
            onClick={() => {

              if (roles?.isRequest) {
                if (!isRequestBtnDisabled) {
                  handleShow(row.nameEmploye, row.bondId, row.bond, row.porcent, row.bondFinal);
                } else {
                  toaster.warning(
                    'No se puede modificar la información, ya fueron cerrados los bonos.'
                  );
                }
              }

              if (roles?.isAuth) {
                if (!isAuthorizeBtnDisabled) {
                  handleShow(row.nameEmploye, row.bondId, row.bond, row.porcent, row.bondFinal);
                } else {
                  if (requestedDate === undefined) {
                    toaster.warning("No se puede modificar la información, aún no han revisado los bonos")
                  } else {
                    toaster.warning(
                      'No se puede modificar la información, ya fueron cerrados los bonos.'
                    );
                  }
                }
              }
            }}
          >
            {row.nameEmploye}
          </div>
        ),
        department: <div style={{ textAlign: 'center' }}>{row.department}</div>,
        job: <div style={{ textAlign: 'center' }}>{row.job}</div>,
        bond: <div style={{ textAlign: 'center' }}>${formatDecimal.format(row.bond)}</div>,
        porcent: <div style={{ textAlign: 'center' }}>{row.porcent}%</div>,
        bondFinal: <div style={{ textAlign: 'center' }}>${formatDecimal.format(row.bondFinal)}</div>,
        requestedBy: (
          <div style={{ textAlign: 'center' }}>
            {row.requestedBy.trim() || 'N/A'}
          </div>
        ),
        aprovedBy: (
          <div style={{ textAlign: 'center' }}>
            {row.aprovedBy.trim() || 'N/A'}
          </div>
        ),
      }));
    }
    return [];
  }, [bondCollaborator, loadingGrid]);

  const isAuthorizeBtnDisabled = useMemo(() => {
    return (
      bondCollaborator.length === 0 ||
      bondCollaborator.some(
        (record) => record.aprovedBy.trim() || !record.requestedBy.trim()
      )
    );
  }, [bondCollaborator]);

  const isRequestBtnDisabled = useMemo(() => {
    return (
      bondCollaborator.length === 0 ||
      bondCollaborator.some((record) => record.requestedBy.trim())
    );
  }, [bondCollaborator]);

  return (
    <div className="row gy-5 g-xl-8">
      <div className="col-xxl-12 col-xl-12 col-md-12 col-lg-12">
        <div className="card card-flush p-5">
          <div className="d-flex justify-content-between align-items-center mb-4">
            <div className="d-flex">
              <div className="me-3">
                <label className="form-label">Apertura de bonos</label>
                <input
                  type="text"
                  className="form-control"
                  value={createdDate || 'N/A'}
                  disabled
                />
              </div>
              <div className="me-3">
                <label className="form-label">Cierre de revisión</label>
                <input
                  type="text"
                  className="form-control"
                  value={requestedDate || 'N/A'}
                  disabled
                />
              </div>
              <div className="me-3">
                <label className="form-label">Cierre de autorización</label>
                <input
                  type="text"
                  className="form-control"
                  value={authorizationDate || 'N/A'}
                  disabled
                />
              </div>
            </div>
            <div className="d-flex align-items-center align-self-end">
              <button
                className="btn btn-light-primary border-btn w-10"
                onClick={handleFilterOpen}
              >
                <KTSVG
                  path="/media/icons/duotune/general/gen021.svg"
                  className="svg-icon svg-icon-5 svg-icon-gray-500"
                />
                <span className="ms-2">Filtrar</span>
              </button>
            </div>
          </div>

          <div className="table-container">
            <TableComponent
              heads={heads}
              rows={rows}
              rowsPerPage={pageSize}
              page={currentPage}
              totalRows={totalRecords}
              setPage={setCurrentPage}
            />
          </div>
          {/* SECCION AUTH BONOS */}
          <div className="d-flex justify-content-between">
            <div>
              {canSeeAperturaButtons && requestedDate && !authorizationDate && (
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleRequestOpening}
                >
                  Apertura de Revisión
                </button>
              )}
              {canSeeAperturaButtons && authorizationDate && (
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleOpeningAuthorization}
                >
                  Apertura de Autorización
                </button>
              )}
            </div>
            <div>
              {roles?.isAuth && (
                <button
                  type="submit"
                  className="btn btn-primary me-4"
                  disabled={isAuthorizeBtnDisabled}
                  onClick={(e) => {
                    e.preventDefault();
                    authorization(token.nameid, false);
                  }}
                >
                  Autorizar
                </button>
              )}
              {roles?.isRequest && (
                <button
                  type="submit"
                  disabled={isRequestBtnDisabled}
                  className="btn btn-primary"
                  onClick={(e) => {
                    e.preventDefault();
                    Swal.fire({
                      title: '¿Desea solicitar la autorización?',
                      text: 'Se enviará la solicitud de autorización para los bonos del departamento.',
                      icon: 'question',
                      showCancelButton: true,
                      cancelButtonText: 'Cancel',
                      confirmButtonText: 'Confirm',
                      reverseButtons: true,
                      customClass: {
                        confirmButton: 'btn btn-primary',
                        cancelButton: 'btn btn-light me-3',
                      },
                      buttonsStyling: false,
                    }).then((result) => {
                      if (result.isConfirmed) {
                        requestAuthorization(token.nameid, true);
                      }
                    });
                  }}
                >
                  Solicitar Autorización
                </button>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Modal para asignar bono */}
      <Modal
        id="kt_modal_create"
        tabIndex={-1}
        aria-hidden="true"
        dialogClassName="modal-dialog"
        show={show}
        onHide={handleClose}
      >
        <div className="modal-content">
          <div className="modal-header">
            <h2 className="text-muted">Asignar Bono</h2>
            <div
              className="btn btn-sm btn-icon btn-active-color-primary"
              onClick={handleClose}
            >
              <KTSVG
                className="svg-icon-2"
                path="/media/icons/duotune/arrows/arr061.svg"
              />
            </div>
          </div>
          <div className="modal-body mx-5 padding-top-00">
            <form
              className="form needs-validation"
              noValidate
              onSubmit={formBondsDepartmentsCollaborator.handleSubmit}
            >
              <div className="mb-3">
                <label className="form-label">Nombre</label>
                <input
                  type="text"
                  className="form-control"
                  value={selectedName}
                  disabled
                />
              </div>
              <div className="mb-3">
                <div className="input-group">
                  <label htmlFor="bondAmount" className="form-label">
                    Bono general
                  </label>
                  <InputGroup>
                    <InputGroup.Text>$</InputGroup.Text>
                    <FormControl
                      type="number"
                      disabled
                      name="bondAmount"
                      value={formBondsDepartmentsCollaborator.values.bondAmount}
                      onChange={formBondsDepartmentsCollaborator.handleChange}
                      onBlur={formBondsDepartmentsCollaborator.handleBlur}
                      isInvalid={
                        !!formBondsDepartmentsCollaborator.errors.bondAmount
                      }
                      onKeyDown={invalidChar}
                    />
                    <FormControl.Feedback type="invalid">
                      {formBondsDepartmentsCollaborator.errors.bondAmount}
                    </FormControl.Feedback>
                  </InputGroup>
                </div>
              </div>
              <div className="mb-3">
                <div className="input-group">
                  <label htmlFor="bondFinal" className="form-label">
                    Bono Final
                  </label>
                  <InputGroup>
                    <InputGroup.Text>$</InputGroup.Text>
                    <FormControl
                      type="number"
                      name="bondFinal"
                      value={formBondsDepartmentsCollaborator.values.bondFinal}
                      onChange={formBondsDepartmentsCollaborator.handleChange}
                      onBlur={formBondsDepartmentsCollaborator.handleBlur}
                      isInvalid={
                        !!formBondsDepartmentsCollaborator.errors.bondFinal
                      }
                      onKeyDown={invalidChar}
                    />
                    <FormControl.Feedback type="invalid">
                      {formBondsDepartmentsCollaborator.errors.bondFinal}
                    </FormControl.Feedback>
                  </InputGroup>
                </div>
              </div>
              {/* <div className="mb-3">
                <label htmlFor="bondPercent" className="form-label">
                  Porcentaje
                </label>
                <InputGroup>
                  <FormControl
                    type="number"
                    name="bondPercent"
                    value={formBondsDepartmentsCollaborator.values.bondPercent}
                    onChange={formBondsDepartmentsCollaborator.handleChange}
                    onBlur={formBondsDepartmentsCollaborator.handleBlur}
                    isInvalid={
                      !!formBondsDepartmentsCollaborator.errors.bondPercent
                    }
                    onKeyDown={invalidChar}
                  />
                  <FormControl.Feedback type="invalid">
                    {formBondsDepartmentsCollaborator.errors.bondPercent}
                  </FormControl.Feedback>
                </InputGroup>
              </div> */}
              <div className="d-flex justify-content-between mt-4">
                <button
                  type="button"
                  className="btn btn-secondary me-2"
                  onClick={handleClose}
                >
                  Cancelar
                </button>
                <button
                  type="submit"
                  className="btn btn-primary"
                  disabled={formBondsDepartmentsCollaborator.isSubmitting}
                >
                  Guardar
                </button>
              </div>
            </form>
          </div>
        </div>
      </Modal>
      {/* Modal del Filtro */}
      <Modal
        id="kt_modal_filter"
        tabIndex={-1}
        aria-hidden="true"
        dialogClassName="modal-dialog"
        show={showFilterModal}
        onHide={handleFilterClose}
      >
        <div className="modal-content">
          <div className="modal-header">
            <h1 className="text-muted mx-5">Filtrar Resultados</h1>
            <div
              className="btn btn-sm btn-icon btn-active-color-primary"
              onClick={handleFilterClose}
            >
              <KTSVG
                className="svg-icon-2"
                path="/media/icons/duotune/arrows/arr061.svg"
              />
            </div>
          </div>
          <div className="modal-body mx-5 padding-top-00">
            <div className="mt-4">
              <label className="form-label fw-bold">
                Seleccione una opción:
              </label>
            </div>
            <select
              className="form-select"
              value={selectedOption}
              onChange={handleSelectChange}
            >
              <option value="">Seleccione</option>
              {filterOptions.map((option) => (
                <option key={option.id} value={option.id}>
                  {option.fecha}
                </option>
              ))}
            </select>
            {fieldToShow && inputFields[fieldToShow as keyof InputFields]}
          </div>
          <div className="modal-body mx-5 padding-top-00"></div>
        </div>
      </Modal>
    </div>
  );
};

export { DetalleBono };
